import { getErrorss } from '../../../../functions/errors/GetErrors'
import { getQueryAdvertises } from '../../../../functions/shared/api/queries/getQueryAdvertises'
import { addAdvertise, advertisesSlice, setAdvertises } from '../../../../store/slices/advertisesSlice'
import { dataFetchingFinish, dataFetchingStart } from '../../../../store/slices/modalSlice'
import { type AppDispatch } from '../../../../store/store'
import { ACCESS_KEY, urlAPI } from '../../../../urls'
import { buildManualAdvertisementLinksUpdate, buildManualAdvertisementPayload } from './manualAdvertisementPayload'
import { type ManualAdvertisementFormValues, type ManualAdvertisementPortalLink, type ManualAdvertisementSubmitResult } from './manualAdvertisement.types'

export const createManualAdvertisement = (values: ManualAdvertisementFormValues) => async (dispatch: AppDispatch): Promise<ManualAdvertisementSubmitResult> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const bodyObject = {
        method: 'POST',
        collection: 'unit-advertises',
        query: getQueryAdvertises(),
        body: buildManualAdvertisementPayload(values)
    }

    try {
        dispatch(dataFetchingStart())
        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            },
            body: JSON.stringify(bodyObject)
        })
        const dataJSON = await response.json()

        if (dataJSON.success === true && dataJSON.response?.error == null && dataJSON.response?.data != null) {
            dispatch(addAdvertise(dataJSON.response.data))
            dispatch(dataFetchingFinish())
            return { isSuccessful: true, advertiseId: Number(dataJSON.response.data.id) }
        }

        const error = getErrorss(dataJSON)
        dispatch(advertisesSlice.actions.advertisesFetchingError({ message: error }))
        dispatch(dataFetchingFinish())
        return { isSuccessful: false, error }
    } catch (error) {
        const message = error instanceof Error ? error.message : 'Could not create advertisement.'
        dispatch(advertisesSlice.actions.advertisesFetchingError({ message }))
        dispatch(dataFetchingFinish())
        return { isSuccessful: false, error: message }
    }
}

export const updateManualAdvertisementPortalLinks = ({
    advertise,
    portalLinks,
    trakheesiId
}: {
    advertise: any
    portalLinks: ManualAdvertisementPortalLink[]
    trakheesiId: string
}) => async (dispatch: AppDispatch): Promise<ManualAdvertisementSubmitResult> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const advertiseId = Number(advertise?.id)
    const bodyObject = {
        method: 'PUT',
        collection: 'unit-advertises',
        id: advertiseId,
        query: getQueryAdvertises(),
        body: {
            Links: buildManualAdvertisementLinksUpdate(advertise, portalLinks, trakheesiId)
        }
    }

    try {
        dispatch(dataFetchingStart())
        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            },
            body: JSON.stringify(bodyObject)
        })
        const dataJSON = await response.json()

        if (dataJSON.success === true && dataJSON.response?.error == null && dataJSON.response?.data != null) {
            dispatch(setAdvertises(dataJSON.response.data))
            dispatch(dataFetchingFinish())
            return { isSuccessful: true, advertiseId }
        }

        const error = getErrorss(dataJSON)
        dispatch(advertisesSlice.actions.advertisesFetchingError({ message: error }))
        dispatch(dataFetchingFinish())
        return { isSuccessful: false, error }
    } catch (error) {
        const message = error instanceof Error ? error.message : 'Could not update advertisement portal links.'
        dispatch(advertisesSlice.actions.advertisesFetchingError({ message }))
        dispatch(dataFetchingFinish())
        return { isSuccessful: false, error: message }
    }
}
